module.exports = __webpack_public_path__ + "media/Voicedemo_Compilatie.08859e38.mp3";